exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ":host{position:absolute;bottom:10px;left:6px;z-index:1;font-size:.9em}#cordContainer>p{margin:0}#coordContainer>p:first-child{margin-top:0;margin-bottom:6px}#coordinatesLine,#scaleLine{color:#fff;text-shadow:#000 0 0 5px,#000 0 0 5px,#000 0 0 5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/coordinate/coordinate.component.css
// module id = 660
// module chunks = 1